import { FeatureFlags } from "../Util/FeatureFlags/FeatureFlags";
import { getFeatureFlags } from "../Util/FeatureFlags/FeatureFlags.prod";

export let featureFlags: FeatureFlags;

export const setFeatureFlags = (requestedFeatureFlags: FeatureFlags) => {
    featureFlags = requestedFeatureFlags;

    // Make feature flags available to legacy code
    (window as any).featureFlags = featureFlags;
};

export const loadFeatureFlagsWithOverrides = () => {
    const baseFeatureFlags = getFeatureFlags();
    if (
        (window as any).overrideFeatureFlags
    && typeof (window as any).overrideFeatureFlags === "function"
    ) {
        (window as any).overrideFeatureFlags(baseFeatureFlags);
    }

    setFeatureFlags(baseFeatureFlags);
};
